import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../../utils/makeResource'
import {hasPipelinesQuery} from '../components/WelcomeScreen/WelcomeScreen.queries'

import type {WelcomePageComponent} from './WelcomePage'

export const WelcomePageEntryPoint: EntryPoint<WelcomePageComponent> = {
  root: makeResource(
    'WelcomePage',
    () =>
      import(
        /* webpackChunkName: "WelcomePage" */
        './WelcomePage'
      ),
  ),
  getPreloadProps: () => ({
    queries: {
      hasPipelines: {
        parameters: getRequest(hasPipelinesQuery),
        variables: {},
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
  }),
}
